import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeReviews() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.50': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <div className="renvia-testimonial-item style-three slick-slide slick-cloned" >
                        <div className="testimonial-content">
                            <div className="quote-ratings-wrap">
                                <div className="quote">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-three/testimonial/quote.png" alt="quote" />
                                </div>
                                <div className="ratings">
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                            <p>“Buying a plot here was the best decision for our family. The team was very supportive and explained every detail clearly. The process was smooth and transparent.”</p>
                            <div className="author-thumb-item">
                                <div className="author-info">
                                    <h5>Mr. Rohit Sharma</h5>
                                    <span className="position">Ex-Army Officers</span>
                                </div>
                                <div className="author-thumb">
                                    <img src="assets/img/Profile.png" alt="author image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="renvia-testimonial-item style-three slick-slide slick-cloned" >
                        <div className="testimonial-content">
                            <div className="quote-ratings-wrap">
                                <div className="quote">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-three/testimonial/quote.png" alt="quote" />
                                </div>
                                <div className="ratings">
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                            <p>“Excellent service and genuine property deals. I was looking for a residential plot for a long time, and they helped me find the perfect location within my budget.”</p>
                            <div className="author-thumb-item">
                                <div className="author-info">
                                    <h5>Mr. Amit Patel</h5>
                                    <span className="position">Software Engineer</span>
                                </div>
                                <div className="author-thumb">
                                    <img src="assets/img/Profile.png" alt="author image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="renvia-testimonial-item style-three slick-slide slick-cloned" >
                        <div className="testimonial-content">
                            <div className="quote-ratings-wrap">
                                <div className="quote">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-three/testimonial/quote.png" alt="quote" />
                                </div>
                                <div className="ratings">
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                            <p>“Very professional team and trustworthy company. All documentation was handled properly, and they guided us at every step.”</p>
                            <div className="author-thumb-item">
                                <div className="author-info">
                                    <h5>Mr. Sanjay Gupta</h5>
                                    <span className="position">Army Officer</span>
                                </div>
                                <div className="author-thumb">
                                    <img src="assets/img/Profile.png" alt="author image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="renvia-testimonial-item style-three slick-slide slick-cloned" >
                        <div className="testimonial-content">
                            <div className="quote-ratings-wrap">
                                <div className="quote">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-three/testimonial/quote.png" alt="quote" />
                                </div>
                                <div className="ratings">
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                            <p>“Great experience working with them. The project location is excellent and prices are very reasonable compared to other developers.”</p>
                            <div className="author-thumb-item">
                                <div className="author-info">
                                    <h5>Mr. Vikas Mishra</h5>
                                    <span className="position">Manager</span>
                                </div>
                                <div className="author-thumb">
                                    <img src="assets/img/Profile.png" alt="author image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="renvia-testimonial-item style-three slick-slide slick-cloned" >
                        <div className="testimonial-content">
                            <div className="quote-ratings-wrap">
                                <div className="quote">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-three/testimonial/quote.png" alt="quote" />
                                </div>
                                <div className="ratings">
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                            <p>“I highly recommend them for anyone looking to invest in property. Honest advice, quick response, and reliable service.”</p>
                            <div className="author-thumb-item">
                                <div className="author-info">
                                    <h5>Mr. Rahul Tiwari </h5>
                                    <span className="position">Business</span>
                                </div>
                                <div className="author-thumb">
                                    <img src="assets/img/Profile.png" alt="author image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="renvia-testimonial-item style-three slick-slide slick-cloned" >
                        <div className="testimonial-content">
                            <div className="quote-ratings-wrap">
                                <div className="quote">
                                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-three/testimonial/quote.png" alt="quote" />
                                </div>
                                <div className="ratings">
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                    <i className="fas fa-star" />
                                </div>
                            </div>
                            <p>From site visit to final registration, everything was handled professionally. We are very happy with our new plot.”</p>
                            <div className="author-thumb-item">
                                <div className="author-info">
                                    <h5>Mr. Deepak Singh</h5>
                                    <span className="position">Normal Family</span>
                                </div>
                                <div className="author-thumb">
                                    <img src="assets/img/Profile.png" alt="author image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

            </Swiper>
        </>
    );
}
